"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Helpers = require('static-site-generator-shared/plugins/lib/helpers');
class EmailDiscountForm extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailValue: '',
      h2Text: 'Up to <span>20% discount</span> when you sign up:',
      errorMsg: 'Email address',
      error: '',
      hideForm: false,
      isDiscountFormVisible: false
    };
    this.timeoutID = null;
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setUpDiscountTimer = this.setUpDiscountTimer.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.goInactive = this.goInactive.bind(this);
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutID);
    this.removeEventListeners();
  }
  componentDidMount() {
    this.setUpDiscountTimer();
  }
  setUpDiscountTimer() {
    const {
      agentData
    } = this.props;
    const {
      groupCode
    } = agentData;
    const shouldShowDiscountForm = !Helpers.getParameterByName('email') && groupCode !== 'MO';
    if (shouldShowDiscountForm) {
      document.addEventListener('mousemove', this.resetTimer, false);
      document.addEventListener('mousedown', this.resetTimer, false);
      document.addEventListener('keypress', this.resetTimer, false);
      document.addEventListener('DOMMouseScroll', this.resetTimer, false);
      document.addEventListener('mousewheel', this.resetTimer, false);
      document.addEventListener('touchmove', this.resetTimer, false);
      document.addEventListener('MSPointerMove', this.resetTimer, false);
      this.startTimer();
    }
  }
  removeEventListeners() {
    document.removeEventListener('mousemove', this.resetTimer, false);
    document.removeEventListener('mousedown', this.resetTimer, false);
    document.removeEventListener('keypress', this.resetTimer, false);
    document.removeEventListener('DOMMouseScroll', this.resetTimer, false);
    document.removeEventListener('mousewheel', this.resetTimer, false);
    document.removeEventListener('touchmove', this.resetTimer, false);
    document.removeEventListener('MSPointerMove', this.resetTimer, false);
  }
  startTimer() {
    /* wait 5 seconds before calling goInactive */
    this.timeoutID = setTimeout(this.goInactive, 5000);
  }
  resetTimer() {
    clearTimeout(this.timeoutID);
    this.startTimer();
  }
  goInactive() {
    this.setState({
      isDiscountFormVisible: true
    });
    this.removeEventListeners();
  }
  validateForm() {
    const {
      emailValue
    } = this.state;
    if (emailValue === '') this.setState({
      errorMsg: 'Please enter your email address',
      error: 'error'
    });
    const emailReg = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    const emailValid = emailReg.test(emailValue);
    return emailValid;
  }
  submitForm() {
    const {
      emailValue
    } = this.state;
    try {
      Helpers.setCookie('Email', emailValue);
      window.tracker.track('marketing', {
        marketing: {
          action: 'subscribe',
          agent_code: this.props.agentData.agent,
          country: 'uk',
          language: 'en',
          brand: 'AP',
          opt_in_message: 'ap_engine_signup_' + window.location.href,
          preferences: {
            frequency: 'fortnightly',
            method: ['email']
          }
        }
      });
      Helpers.setCookie('discount_form_Email', emailValue);
      // TEMP TECH DEBT FIX - waiting on responsys to get fixed!
      window.location.href = '?agent=BE140';
      // this.setState({
      //   h2Text: 'We’ve sent a verification link to your email to instantly apply your discount. Please check your inbox.',
      //   hideForm: true
      // })
    } catch (e) {
      // console.log(e)
    }
  }
  handleChange(e) {
    this.setState({
      emailValue: e.target.value,
      error: ''
    });
  }
  handleSubmit(e) {
    e.preventDefault();
    this.validateForm() && this.submitForm();
  }
  render() {
    const {
      h2Text,
      hideForm,
      isDiscountFormVisible
    } = this.state;
    const {
      pageName
    } = this.props;
    const url = pageName !== 'index' ? `${pageName}.html` : '';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "discount-content"
    }, isDiscountFormVisible && /*#__PURE__*/_react.default.createElement("div", {
      className: "discount-content-inner"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "emailHead",
      dangerouslySetInnerHTML: {
        __html: h2Text
      }
    }), !hideForm && /*#__PURE__*/_react.default.createElement("form", {
      acceptCharset: "UTF-8",
      action: "https://email.holidayextras.co.uk/pub/rf",
      id: "email-signup",
      onSubmit: this.handleSubmit
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "form-item webform-component webform-component-email webform-component--email-address"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "form-control required",
      id: "email-Id",
      type: "email",
      name: "EMAIL_ADDRESS_",
      value: this.state.emailValue,
      placeholder: this.state.errorMsg,
      onChange: this.handleChange,
      "data-error": this.state.error
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "AP",
      value: "1"
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "AGENT",
      value: "BE140"
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "STAMP",
      value: new Date().getTime()
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "EMAIL_PERMISSION_STATUS_",
      value: "I"
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "EMAIL_DELIVERABILITY_STATUS_",
      value: "D"
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "LANGUAGE",
      value: "EN"
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "REFERRER",
      value: 'https://' + 'www.airparks.co.uk' + '/' + url
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "hidden",
      name: "_ri_",
      value: "X0Gzc2X%3DYQpglLjHJlYQGiPIy5uKfPlrNGAkzb9G4zeKJg3zcoUfuYCehqHzfhRoVwjpnpgHlpgneHmgJoXX0Gzc2X%3DYQpglLjHJlYQGrwciWW7Ocn7TT44aCcS1qbg3zcoUfuYCehqHzfhRo"
    })), /*#__PURE__*/_react.default.createElement("input", {
      className: "btn btn-lg btn-primary emailSubmit",
      name: "op",
      type: "submit",
      value: "Apply"
    }))));
  }
}
var _default = exports.default = EmailDiscountForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/DiscountBanner.js
// module id = 754
// module chunks = 119